export default "__VITE_ASSET__4DJF6vX6__"